/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * GridRow CSS
 */
export const styles = css`
  .row-base {
    display: grid;
    grid-template-columns: var(--nile-grid-columns);
    border-bottom: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
    background-color: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    position: relative;
  }

  .row-bg {
    grid-column: 1 / -1;
    pointer-events: none;
    z-index: 0;
    display: none;
  }

  .row-slot {
    grid-column: 1 / -1;
    display: contents;
    z-index: 1;
  }

  /* check it one more time */
  :host([disabled]) {
    background: var(--nile-colors-white-base);
    border-bottom: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
    opacity: 0.3;
  }

  :host([selected]) {
    background: var(--nile-colors-primary-100);
  }

  :host-context(nile-grid-body):host(:last-child)::part(grid-row-base) {
    border-bottom: none;
  }
`;

export default [styles];
